var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnimatedAlram1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 67V62.3C3 60.48 4.48 59 6.3 59H65.76C67.55 59 69 60.45 69 62.24V67H3Z",
    fill: "#534741"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M65.76 60C67 60 68 61.01 68 62.24V66H4V62.3C4 61.03 5.03 60 6.3 60H65.76ZM65.76 58H6.3C3.92 58 2 59.92 2 62.3V67.94C2 67.97 2.03 68 2.06 68H69.94C69.97 68 70 67.97 70 67.94V62.24C70 59.9 68.1 58 65.76 58Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16 58V29.23C16 18.08 25.08 9 36.23 9C47.34 9 56.38 18.04 56.38 29.15V58H16Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M36.23 10C46.79 10 55.38 18.59 55.38 29.15V57H17V29.23C17 18.63 25.63 10 36.23 10ZM36.23 8C24.51 8 15 17.51 15 29.23V58.46C15 58.76 15.24 59 15.54 59H56.86C57.16 59 57.4 58.76 57.4 58.46V29.15C57.39 17.47 47.92 8 36.23 8Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M39.54 18.51C40.03 18.63 40.51 18.78 40.97 18.97C40.73 18.87 41.16 19.06 41.16 19.06C41.25 19.1 41.34 19.15 41.43 19.19C41.65 19.3 41.87 19.43 42.09 19.56C42.31 19.69 42.52 19.83 42.72 19.97C42.72 19.97 43.09 20.25 42.9 20.1C42.98 20.16 43.06 20.23 43.13 20.29C43.53 20.63 43.91 21 44.26 21.4C44.34 21.5 44.43 21.59 44.51 21.69C44.39 21.55 44.58 21.78 44.61 21.83C44.76 22.04 44.91 22.26 45.05 22.49C45.19 22.72 45.31 22.95 45.43 23.18C45.49 23.3 45.55 23.42 45.6 23.54C45.62 23.59 45.64 23.64 45.67 23.68C45.63 23.59 45.63 23.59 45.67 23.69C45.87 24.18 46.02 24.68 46.14 25.2C46.2 25.46 46.25 25.71 46.29 25.98C46.31 26.09 46.31 26.08 46.29 25.97C46.3 26.02 46.3 26.07 46.31 26.13C46.32 26.29 46.34 26.44 46.35 26.6C46.4 27.38 47.01 28.14 47.85 28.1C48.62 28.07 49.4 27.44 49.35 26.6C49.05 21.4 45.43 16.89 40.34 15.64C39.58 15.45 38.68 15.88 38.49 16.69C38.32 17.44 38.73 18.31 39.54 18.51Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "lights"
  }, /*#__PURE__*/React.createElement("g", {
    id: "light5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18.4533 8.4742L21.22 11.5405C21.2345 11.5405 18.4533 8.4742 18.4533 8.4742Z",
    fill: "#534741"
  }), /*#__PURE__*/React.createElement("path", {
    className: "light",
    id: "Vector_7",
    d: "M18.4533 7C18.1056 7 17.758 7.13268 17.4683 7.38329C16.8744 7.92875 16.8454 8.87224 17.3814 9.46192L20.1481 12.5283C20.4378 12.8378 20.8289 13 21.22 13C21.5676 13 21.9153 12.8673 22.205 12.6167C22.7989 12.0713 22.8279 11.1278 22.2919 10.5381L19.5252 7.47174C19.2355 7.14742 18.8444 7 18.4533 7Z",
    fill: "#ED1C24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "light4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M36.5 0C35.675 0 35 0.63 35 1.4V5.6C35 6.37 35.675 7 36.5 7C37.325 7 38 6.37 38 5.6V1.4C38 0.63 37.325 0 36.5 0Z",
    fill: "#ED1C24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "light3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M49.8106 12.3721C49.2127 11.8543 49.169 10.9727 49.7085 10.3989L52.4646 7.46001C53.0041 6.88623 53.9228 6.84424 54.5207 7.36204C55.1186 7.87985 55.1623 8.76151 54.6228 9.3353L51.8667 12.2742C51.3272 12.848 50.4085 12.8899 49.8106 12.3721Z",
    fill: "#534741"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M53.5437 7.01217C53.15 7.01217 52.7562 7.16611 52.4646 7.47399L49.7085 10.4129C49.169 10.9867 49.2127 11.8683 49.8106 12.3861C50.0877 12.624 50.4377 12.75 50.7876 12.75C51.1814 12.75 51.5751 12.596 51.8667 12.2882L54.6228 9.34928C55.1623 8.7755 55.1186 7.89383 54.5207 7.37603C54.2436 7.12413 53.8936 7.01217 53.5437 7.01217Z",
    fill: "#ED1C24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "light2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M15 26.5C15 27.325 14.46 28 13.8 28H10.2C9.54 28 9 27.325 9 26.5C9 25.675 9.54 25 10.2 25H13.8C14.46 25 15 25.675 15 26.5Z",
    fill: "#534741"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M13.8 25H10.2C9.54 25 9 25.675 9 26.5C9 27.325 9.54 28 10.2 28H13.8C14.46 28 15 27.325 15 26.5C15 25.675 14.46 25 13.8 25Z",
    fill: "#ED1C24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "light1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M58 27.5C58 26.675 58.63 26 59.4 26H63.6C64.37 26 65 26.675 65 27.5C65 28.325 64.37 29 63.6 29H59.4C58.63 29 58 28.325 58 27.5Z",
    fill: "#534741"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M63.6 26H59.4C58.63 26 58 26.675 58 27.5C58 28.325 58.63 29 59.4 29H63.6C64.37 29 65 28.325 65 27.5C65 26.675 64.37 26 63.6 26Z",
    fill: "#ED1C24"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimatedAlram1);
export default __webpack_public_path__ + "static/media/AnimatedAlram1.c4e792aa8656ef24b23b0c26d5f66c47.svg";
export { ForwardRef as ReactComponent };